// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddStorageYardDialog {
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: space-between;
  background-color: var(--color-grayscale-1);
  padding: 30px;
  border-radius: 2px;
  background-repeat: no-repeat;
  width: 742px;
}

  /* height: 382px; */

  .AddStorageYardDialog__spinner {
    height: 20%;
    align-self: center;
  }

  .AddStorageYardDialog__spinner-container {
      align-items: center;
      justify-content: center;
    }

  .AddStorageYardDialog__title-container {
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;
    }

  .AddStorageYardDialog__title-text {
      font-size: 24px;
      font-weight: 600;
      color: #2a2d30;
      margin-bottom: 10px;
    }

  .AddStorageYardDialog__title-sub-text {
      font-size: 16px;
      color: #2a2d30;
    }

  .AddStorageYardDialog__checkbox {
    min-height: unset;
    margin-top: 2px;
  }

  .AddStorageYardDialog__appt-container {
      display: flex;
      width: 160px;
    }

  .AddStorageYardDialog__appt-main {
      width: 100%;
    }

  .AddStorageYardDialog__appt-main-row {
        font-size: 14px;
        color: #2a2d30;
        margin-bottom: 5px;
      }

  .AddStorageYardDialog__appt-main-row:first-child {
          font-weight: 600;
          margin-bottom: 10px;
        }

  .AddStorageYardDialog__appt-main-row:last-child {
          margin-bottom: 0;
        }

  .AddStorageYardDialog__buttons {
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }

  .AddStorageYardDialog__buttons > * {
      width: 120px;
      height: 40px;
    }

  .AddStorageYardDialog__buttons > *:first-child {
        margin-right: 10px;
      }

  .AddStorageYardDialog__toggles {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }

  .AddStorageYardDialog__content {
    display: flex;
    justify-content: space-between;
  }

  .AddStorageYardDialog__input-section {
    width: 140px;
  }

  .AddStorageYardDialog__input-section-title {
      font-weight: 500;
      font-size: 14px;
      line-height: 15px;
      margin-bottom: 2px;
    }

  .AddStorageYardDialog__input-section-sub-title {
      color: #74777a;
      font-weight: 500;
      font-size: 12px;
      line-height: 13px;
    }

  .AddStorageYardDialog__input-section-inputs {
      margin-top: 8px;
    }
`, "",{"version":3,"sources":["webpack://./app/pages/DispatchPage/components/AddStorageYardDialog/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AAiHd;;EA/GE,mBAAmB;;EAEnB;IACE,WAAW;IACX,kBAAkB;EAMpB;;EAJE;MACE,mBAAmB;MACnB,uBAAuB;IACzB;;EAIA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;IACrB;;EAEA;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,mBAAmB;IACrB;;EAEA;MACE,eAAe;MACf,cAAc;IAChB;;EAGF;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAGE;MACE,aAAa;MACb,YAAY;IACd;;EAEA;MACE,WAAW;IAgBb;;EAdE;QACE,eAAe;QACf,cAAc;QACd,kBAAkB;MAUpB;;EARE;UACE,gBAAgB;UAChB,mBAAmB;QACrB;;EAEA;UACE,gBAAgB;QAClB;;EAKN;IACE,aAAa;IACb,WAAW;IACX,yBAAyB;EAU3B;;EARE;MACE,YAAY;MACZ,YAAY;IAKd;;EAHE;QACE,kBAAkB;MACpB;;EAIJ;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,YAAY;EAmBd;;EAjBE;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,kBAAkB;IACpB;;EAEA;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB;IACnB;;EAEA;MACE,eAAe;IACjB","sourcesContent":[".AddStorageYardDialog {\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  justify-content: space-between;\n  background-color: var(--color-grayscale-1);\n  padding: 30px;\n  border-radius: 2px;\n  background-repeat: no-repeat;\n  width: 742px;\n\n  /* height: 382px; */\n\n  &__spinner {\n    height: 20%;\n    align-self: center;\n\n    &-container {\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  &__title {\n    &-container {\n      display: flex;\n      flex-direction: column;\n      margin-bottom: 40px;\n    }\n\n    &-text {\n      font-size: 24px;\n      font-weight: 600;\n      color: #2a2d30;\n      margin-bottom: 10px;\n    }\n\n    &-sub-text {\n      font-size: 16px;\n      color: #2a2d30;\n    }\n  }\n\n  &__checkbox {\n    min-height: unset;\n    margin-top: 2px;\n  }\n\n  &__appt {\n    &-container {\n      display: flex;\n      width: 160px;\n    }\n\n    &-main {\n      width: 100%;\n\n      &-row {\n        font-size: 14px;\n        color: #2a2d30;\n        margin-bottom: 5px;\n\n        &:first-child {\n          font-weight: 600;\n          margin-bottom: 10px;\n        }\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n\n  &__buttons {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n\n    & > * {\n      width: 120px;\n      height: 40px;\n\n      &:first-child {\n        margin-right: 10px;\n      }\n    }\n  }\n\n  &__toggles {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: flex-start;\n  }\n\n  &__content {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &__input-section {\n    width: 140px;\n    \n    &-title {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 15px;\n      margin-bottom: 2px;\n    }\n\n    &-sub-title {\n      color: #74777a;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 13px;\n    }\n\n    &-inputs {\n      margin-top: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
